import Api from "./api";

export const getEnableTagsOnusers = async (id) => {
  let data = [];
  await Api.get("/configusers/enable-tags-on-users")
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};
